<template>
  <div class="rate-wrapper">
    <p v-if="ratePerMinute" class="upto" :class="{ single: !hasMultipleRates }">up to</p>
    <p v-else class="from" :class="{ single: !hasMultipleRates }">{{ $t('rateFinder.from') }}</p>
    <p v-if="ratePerMinute" class="minutes-amount">{{ ratePerMinute }} {{ $t('rateFinder.rate.unit') }}</p>
    <p v-else class="minutes-amount">
      {{ amount.rate }}<span class="rate-unit">/{{ amount.unit }}</span>
    </p>
    <div class="rate-type-wrapper">
      <PhoneIcon v-if="isFlat" />
      <MobileIcon v-else-if="type === 'mobile'" />
      <LandlineIcon v-else-if="type === 'landline'" />
      <PremiumIcon v-else />
      <p class="rate-type" v-if="!isFlat && title">{{ title }}</p>
      <p class="rate-type" v-else>
        {{
          isFlat
            ? $t('rateFinder.rateType.flatRate')
            : isMobile
              ? $t('rateFinder.rateType.mobile')
              : $t('rateFinder.rateType.landline')
        }}
      </p>
    </div>
    <p v-if="ratePerMinute" class="from_rate">
      {{
        hasMultipleRates
          ? $t('rateFinder.fromAmount', { amount: `${amount.rate}/${amount.unit}` })
          : `${amount.rate}/${amount.unit}`
      }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import MobileIcon from '@/components/icons/MobileIcon.vue';
import LandlineIcon from '@/components/icons/LandLineIcon.vue';
import PremiumIcon from '@/components/icons/PremiumIcon.vue';
import PhoneIcon from './icons/PhoneIcon.vue';
import { RateCategory } from '@/types/rates';

export default defineComponent({
  name: 'RateTypeCard',
  components: { MobileIcon, LandlineIcon, PremiumIcon, PhoneIcon },
  props: {
    isMobile: {
      type: Boolean,
      required: false,
      default: true,
    },
    hasMultipleRates: {
      type: Boolean,
      required: false,
      default: false,
    },
    ratePerMinute: {
      type: Number,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    amount: {
      type: Object as PropType<{ rate: string; unit: string }>,
      required: true,
    },
    isFlat: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: Object as PropType<RateCategory>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.rate-wrapper {
  min-width: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    margin: 0;
  }

  .minutes-amount {
    font-size: 1.5rem;
    font-weight: 600;
  }

  .rate-type-wrapper {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    margin-top: 0.5rem;
  }

  .from,
  .upto,
  .minutes-amount {
    color: $color-space-blue;
  }

  .rate-unit,
  .rate-type,
  .from_rate,
  .rate-type-wrapper {
    color: $color-liberty;
  }

  .rate-unit,
  .from,
  .upto,
  .rate-type-wrapper {
    font-size: 0.875rem;
  }

  .rate-unit {
    font-weight: normal;
  }

  .single {
    color: white;
  }

  .upto {
    text-align: center;
  }
}
</style>
